import React, { useRef, useState, useEffect } from "react";
import { ReactComponent as ImportIcon } from "../../../../assets/import.svg";
import { ReactComponent as ExportIcon } from "../../../../assets/export.svg";
import { ReactComponent as DeleteIcon } from "../../../../assets/delete-icon.svg";
import ShippingIcon from "../../../../assets/shipping_icon.png";
import { ReactComponent as CloseIcon } from "../../../../assets/e648f99b268782f39ea1442529369aa3_555555.svg";
import { Row, Col, Button, Popover, Radio, message } from "antd";
import { baseURL } from "../../../../globalUtils/axiosConfig";
import { CloseOutlined, DownloadOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import axios from "axios";
import "./index.less";
import UseDocControlPermissions from "../../permissions/useDocControlPermissions";


const DeliveryNote = ({ debounce, project_id, onTypeChange, mcPermissions = {} }) => {
  const [selectedType, setSelectedType] = useState(null);
  const [generateType, setGenerateType] = useState(null);
  const [attachmentType, setAttachmentType] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filename, setFilename] = useState(null);
  const [fileUploaded, setFileUploaded] = useState(null);
  const [importBtnClicked, setImportBtnClicked] = useState(false);
  const [flowCompleted, setFlowCompleted] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const { allTemplates } = useSelector((state) => state.materialTemplatesReducer);
  const inputFile = useRef(null);
  const [, canEdit] = UseDocControlPermissions();
  
  // Sample file mapping based on type
  const sampleFiles = {
    material: "Import_Template_-_Material_Control_Register_NEW.xlsx",
    bolts: "Import_Template_-_Bolts_NEW.xlsx",
  };

  const handleDownload = () => {
    let url = `${baseURL}/${filename}`;
    window.open(url, "_blank");
  };
  
  const handleSampleFileDownload = () => {
    if (!selectedType || !sampleFiles[selectedType]) return;
    
    // Use frontend URL (port 3001) instead of baseURL for sample files
    let url = `/sample-files/${sampleFiles[selectedType]}`;
    window.open(url, "_blank");
  };

  const handleSave = async (type) => {
    setSelectedType(type);
    
    // Different actions based on the selected option
    if (type === 'generate') {
      // For generate option, just show the radio buttons - no API call needed
      setSuccess(true);
    } else if (type === 'attach') {
      // For attach option, we'll show file upload directly
      setSuccess(true);
    } else if (type === 'batchUpdateGrv') {
      setSuccess(true);
      // Pass the selected type to the parent component
      if (onTypeChange) {
        onTypeChange(type);
      }
      // Auto-close the dropdown after selection
      setIsVisible(false);
    }
  };
  
  const handleGenerateTypeChange = (type) => {
    setGenerateType(type);
    // Handle the generate type selection
    // Pass the selected type to the parent component if callback exists
    if (onTypeChange) {
      onTypeChange(type);
    }
    // Auto-close the dropdown after selection
    setIsVisible(false);
  };

  const handleAttachmentTypeChange = (type) => {
    setAttachmentType(type);
    // Handle the generate type selection
    // Pass the selected type to the parent component if callback exists
    if (onTypeChange) {
      onTypeChange(type);
    }
    // Auto-close the dropdown after selection
    setIsVisible(false);
  };

  const cleanupFun = () => {
    setSelectedType(null);
    setSuccess(false);
    setFilename(null);
    setFileUploaded(null);
    setImportBtnClicked(false);
    setFlowCompleted(false);
    setErrorMessage(null);
  };

  const onOpenChange = (e) => {
    if (!e) {
      cleanupFun();
    }
  };

  const handleClose = () => {
    setIsVisible(false);
    cleanupFun();
  };

  useEffect(() => {
    return () => {
      cleanupFun();
    };
  }, []);

  const handleImage = (imgObj, e) => {
    e.currentTarget.value = null;

    const isValid = /\.(xls|xlsx|csv|)$/i.test(imgObj.name);

    if (isValid) {
      if (imgObj) {
        setFileUploaded(imgObj);
      }
    } else {
      message.error("This file format is not supported.");
    }
  };

  const handleImportFile = async () => {
    setLoading(true);
    setErrorMessage(null);

    const fd = new FormData();
    fd.append("documents", fileUploaded);
    fd.append("type", selectedType);
    try {
      const res = await axios.post(
        `${baseURL}/material-control-registers/import/${project_id}`,
        fd,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      const { status } = res;

      if (status === 200 || status === 201) {
        const { success } = res.data;
        if (success) {
          debounce();
          setFlowCompleted(true);
        } else {
          const error = res.data?.errors || "Import failed";
          setErrorMessage(error);
        }
      } else {
        setErrorMessage("Something went wrong!");
      }
      setLoading(false);
    } catch (error) {
      const errorMsg = error.response?.data?.message || error.message || "Something went wrong!";
      setErrorMessage(errorMsg);
      setLoading(false);
      console.log("error", error);
    }
  };

  const handleDeleteFile = () => {
    setFileUploaded(null);
    setImportBtnClicked(false);
  };

  const CloseBtnSection = () => {
    return (
      <Row justify="center" gutter={[0, 20]} className="close-btn-row">
        <Col span={24}>
          {errorMessage ? (
            <div className="error-text">{errorMessage}</div>
          ) : (
            <div className="success-text">Document Imported Successfully</div>
          )}
        </Col>
        {!errorMessage && (
          <Col span={24} className="done-btn-col">
            <Button size="small" onClick={handleClose} className="done-btn">
              Done
            </Button>
          </Col>
        )}
      </Row>
    );
  };

  const SuccessSection = () => {
    // Different content based on the selected option
    if (selectedType === 'generate') {
      return <GenerateSection />;
    } else if (selectedType === 'attach') {
      return <AttachmentSection />;
    } else if (selectedType === 'batchUpdateGrv') {
      
    } else {
      return <Content />;
    }
  };

  const UploadFileBtn = () => {
    return (
      <Button
        size="middle"
        icon={<ImportIcon />}
        loading={loading}
        // onClick={handleSave}
        className={`export-btn`}
      >
        UPLOAD FILE
      </Button>
    );
  };

  const Content = () => {
    return (
      <Row justify="center" gutter={[0, 20]} className="parent-div">
        <Col span={24} className="choose-col">
          <div className="delivery-options">
            <div className="please-select">Please select:</div>
            <Radio.Group 
              onChange={(e) => handleSave(e.target.value)} 
              value={selectedType}
              className="delivery-radio-group"
              buttonStyle="solid"
            >
              <div className="delivery-option-row">
                <span className="option-text">Generate Delivery Note</span>
                <Radio value="generate" className="delivery-radio-option" />
              </div>
              <div className="delivery-option-row">
                <span className="option-text">Attach Signed Delivery Note</span>
                <Radio value="attach" className="delivery-radio-option" />
              </div>
              {mcPermissions?.site_receipt?.add_edit_grv && (
                <div className="delivery-option-row">
                  <span className="option-text">Batch Update GRV#</span>
                  <Radio value="batchUpdateGrv" className="delivery-radio-option" />
                </div>
              )}
            </Radio.Group>
          </div>
        </Col>
        {success ? (
          <SuccessSection />
        ) : (
          <Col>{filename !== null && <UploadFileBtn />}</Col>
        )}
      </Row>
    );
  };

  const GenerateSection = () => {
    return (
      <Row justify="center" gutter={[0, 20]} className="parent-div">
        <Col span={24} className="choose-col">
          <div className="delivery-options">
            <div className="please-select">Generate Delivery Note From:</div>
            <Radio.Group 
              onChange={(e) => handleGenerateTypeChange(e.target.value)} 
              value={generateType}
              className="delivery-radio-group"
              buttonStyle="solid"
            >
              <div className="delivery-option-row" style={{ border: '1px solid #c0392b', borderRadius: '4px', padding: '8px', marginBottom: '8px' }}>
                <span className="option-text" style={{ color: '#c0392b' }}>QC Release</span>
                <Radio value="qcRelease" className="delivery-radio-option" />
              </div>
              <div className="delivery-option-row" style={{ border: '1px solid #ffc000', borderRadius: '4px', padding: '8px', marginBottom: '8px' }}>
                <span className="option-text" style={{ color: '#ffc000' }}>Corrison Protection/<br />Delivery to Workshop</span>
                <Radio value="deliveryNoteCorrisonProtection" className="delivery-radio-option" />
              </div>
              <div className="delivery-option-row" style={{ border: '1px solid #3498db', borderRadius: '4px', padding: '8px', marginBottom: '8px' }}>
                <span className="option-text" style={{ color: '#3498db' }}>Delivery to Site</span>
                <Radio value="deliveryToSite" className="delivery-radio-option" />
              </div>
            </Radio.Group>
          </div>
        </Col>
      </Row>
    );
  };

  const AttachmentSection = () => {
    return (
      <Row justify="center" gutter={[0, 20]} className="parent-div">
        <Col span={24} className="choose-col">
          <div className="delivery-options">
            <div className="please-select">Attach Signed Delivery Note</div>
            <Radio.Group 
              onChange={(e) => handleAttachmentTypeChange(e.target.value)} 
              value={attachmentType}
              className="delivery-radio-group"
              buttonStyle="solid"
            >
              <div className="delivery-option-row" style={{ border: '1px solid #ffc000', borderRadius: '4px', padding: '8px', marginBottom: '8px' }}>
                <span className="option-text" style={{ color: '#ffc000' }}>Corrison Protection/<br />Delivery to Workshop</span>
                <Radio value="signedDeliveryNoteCorrisonProtection" className="delivery-radio-option" />
              </div>
              <div className="delivery-option-row" style={{ border: '1px solid #3498db', borderRadius: '4px', padding: '8px', marginBottom: '8px' }}>
                <span className="option-text" style={{ color: '#3498db' }}>Delivery to Site</span>
                <Radio value="signedDeliveryToSite" className="delivery-radio-option" />
              </div>
              <div className="delivery-option-row" style={{ border: '1px solid #2ecc71', borderRadius: '4px', padding: '8px', marginBottom: '8px' }}>
                <span className="option-text" style={{ color: '#2ecc71' }}>Site Receipt</span>
                <Radio value="signedSiteReceipt" className="delivery-radio-option" />
              </div>
            </Radio.Group>
          </div>
        </Col>
      </Row>
    );
  };

  const Title = () => {
    return (
      <Row justify="space-between">
        <Col className="title">Delivery Note</Col>
        <Col>
          <CloseOutlined onClick={handleClose} />
        </Col>
      </Row>
    );
  };

  return (
    <Popover
      overlayClassName="export-popover"
      placement="topRight"
      getPopupContainer={() =>
        document.getElementsByClassName(
          "ant-layout-content layout-content site-layout-background custom-textarea"
        )[0]
      }
      content={ selectedType === 'generate' && success ? 
      <GenerateSection /> : 
      selectedType === 'attach' && success ? 
      <AttachmentSection /> : 
      <Content />}
      onOpenChange={onOpenChange}
      title={<Title />}
      trigger="click"
      open={isVisible}
      overlayStyle={{ maxHeight: 'none', height: 'auto', overflow: 'visible' }}
      onVisibleChange={(e) => {
        // Disabled click functionality
        canEdit && setIsVisible(e);
      }}
    >
      <div style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
        <img 
          src={ShippingIcon} 
          alt="Delivery Note" 
          className={canEdit ? "orange-icon" : "orange-icon cursor-not-allowed"} 
          style={{ width: '28px', height: '21px', cursor: 'pointer' }} 
        />
        {(selectedType || generateType) && (
          <CloseIcon 
            className="red-close-icon"
            style={{ 
              position: 'absolute', 
              top: '-8px', 
              right: '-8px', 
              width: '16px', 
              height: '16px',
              backgroundColor: 'white',
              borderRadius: '50%',
              cursor: 'pointer'
            }} 
            onClick={(e) => {
              e.stopPropagation();
              setSelectedType(null);
              setGenerateType(null);
              setAttachmentType(null);
              cleanupFun();
              window.location.reload();
            }}
          />
        )}
      </div>
    </Popover>
  );
};

export default DeliveryNote;
